import { render } from "./Bollo.vue?vue&type=template&id=112a93bd&scoped=true"
import script from "./Bollo.vue?vue&type=script&lang=js"
export * from "./Bollo.vue?vue&type=script&lang=js"

import "./Bollo.vue?vue&type=style&index=0&id=112a93bd&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112a93bd"]])

export default __exports__